import React from "react";
import '../App.css'
import {ReactComponent as Eye} from '../images/Eye1.svg'
import {ReactComponent as Link} from '../images/Link.svg'
const Resume = () => {


  const UpResume = () => {
    window.location.href = 'https://hh.kz/applicant/resumes/view?resume=c0134a50ff0db13e980039ed1f716d5564565a'
  }

  const Profile = () => {
    window.location.href = 'https://www.linkedin.com/in/yelaman-zhanibekov-3935a6303/'
  }
  return (
  <div className="cv-container" >
        <div className="container1" onClick={Profile}> 
        <Eye className="eye1" />
          <a  className="blanc1" href="https://www.linkedin.com/in/yelaman-zhanibekov-3935a6303/"
          >View CV</a>
          <Link className="link"/>
        </div>
        <div className="container2" onClick={UpResume}>
        <Eye className="eye2"></Eye>
          <a className="blanc2">Download CV</a>
          <Link className="link2"/>
        </div>

        <div className="Education">
        <h1>EDUCATION</h1>  
        </div>    
      <hr/>
      <div className="University">
        <div className="create-line-left">
          University of Mukhtar Auezov
          <p>Computer hardware and software</p>
          <p className="country">Shymkent, Kazakhstan  🇰🇿 <br /> 2020-2024</p>
        </div>
      </div>

      <div className="Experience">
        <h1>Experience</h1>
      </div>
      <hr />
      <div className="Qoqus">
      <div className="create-line-left2">
          Vue Frontend Developer - "Qoqus startup".
          <p>Almaty, Kazakhstan 🇰🇿 <br/>Jun 2022 - Aug 2022</p>
          <p>-Development and support of cross-browser and mobile user interfaces (UI) based on design layouts.</p>
          <p>-Creating interactive and adaptive interface elements using Vue, JavaScript, HTML and CSS.</p>
          <p>-Optimization and acceleration of website page loading, ensuring their high performance and user-friendliness.</p>
          <p>- Assess current trends in web development and use the latest tools and technologies to create high-quality user interfaces.</p>
          <p>- Collaborate with designers, backend developers and other team members to ensure the quality of the final product and the delivery of projects on time.</p>
          <p>-Participation in the process of code review of project work and debugging user interface errors.</p>
          <p>-Testing and documenting Frontend code, ensuring its maintainability and scalability.</p>
       </div>
      </div>
      <div className="Umag">
        <div className="create-line-left3">
          Senior System Administrator - "Umag"
          <p>Almaty, Kazakhstan 🇰🇿 <br/> Jan 2023 - Jun 2024</p>
          <p>- Carrying out work on the acquisition, maintenance, repair and improvement of technical equipment;</p>
          <p>- elimination of minor or major faults in technical equipment;</p>
          <p>-Implementation of installation of network (operational and application) software;</p>
          <p>-Ensuring stable and uninterrupted operation of the local network working with the Java language;</p>
          <p>-Maintenance of local network users (creation of domain names and mailboxes); Anti-virus protection of computers, networks, servers working with TCP, UDP protocols;</p>
          <p>-Installation, configuration, updating of 1C or Umag, GBS software products;</p>
          <p>-Development of reports, processing, making changes to configurations on the Umag platform.</p>
        </div>
      </div>
      <div className="Blog">
          <div className="create-line-left4">
            React FullStack Developer - "Zhanibekov-Blog"
            <p>Shymkent, Kazakhstan 🇰🇿 <br /> Oct 2023 - May 2024</p>
            <p>-Assistance in software design and development;</p>
            <p>-Writing clean code for frontend and backend parts;</p>
            <p>-Testing and debugging;</p>
            <p>-Design of data model and architecture;</p>
            <p>-Testing and support of adaptive application design;</p>
            <p>-Working with graphic designers to create new features;</p>
            <p>Development of RESTful/MongoDB APIs and services;</p>
          </div>
      </div>
      <div className="languages">languages</div>
      <hr />
      <div className="create-line-left5">
        English <br/>
        Pre Intermediate
      </div>
      <div className="create-line-left6">
        KAZAKH <br/> NATIVE
      </div>

      <div className="create-line-left7">
        Russian <br/> NATIVE
      </div>

   </div> 

  )
}
export default Resume;